import { useSetAtom } from "jotai";
import { useCallback } from "react";

import { AlertInterface, alertListAtom, AlertTypes } from "@/utils/atoms";
import { isSessionExpiredModalShown } from "@/utils/sessionExpiryError";

export const useAlert = () => {
  const setAlertList = useSetAtom(alertListAtom);

  const showAlert = useCallback(
    (alert: AlertInterface) => {
      if (alert.type === AlertTypes.error && isSessionExpiredModalShown()) {
        return;
      }

      setAlertList((prev) => [...prev, alert]);
    },
    [setAlertList],
  );

  return showAlert;
};
